let body = document.querySelector("body");
let footerHeight = document.getElementById("footerHeight").offsetHeight;

if ($(window).width() > 768) {
  body.style.paddingBottom = footerHeight - 34 + "px";
}
